var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 19,
    viewBox: "0 0 41 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 17,
    rx: 4,
    fill: "url(#paint0_linear_3820_5180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3820_5180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3582 4.27273V13H13.9519L9.83973 7.0554H9.76728V13H8.18632V4.27273H9.60109L13.709 10.2216H13.7857V4.27273H15.3582ZM17.0808 13V4.27273H22.757V5.59801H18.6618V7.96733H22.4629V9.29261H18.6618V11.6747H22.7911V13H17.0808ZM26.2066 13L23.7435 4.27273H25.4438L27.0162 10.6861H27.0972L28.7762 4.27273H30.323L32.0063 10.6903H32.083L33.6554 4.27273H35.3557L32.8926 13H31.333L29.5858 6.87642H29.5176L27.7662 13H26.2066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3820_5180",
    x: 4.18555,
    y: 2.27295,
    width: 35.1699,
    height: 16.7271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3820_5180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3820_5180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3820_5180",
    x1: 33.7111,
    y1: 15.8667,
    x2: -1.36322,
    y2: 5.95961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.264869,
    stopColor: "#1677AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3989B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/New.a39ac8aa81a562bd90f1f7987b161e90.svg";
export { ForwardRef as ReactComponent };